import React, { useState } from "react"
import styled from "@emotion/styled"
import { Flex, Box } from "@rebass/grid/emotion"

import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"
import { TextElementMen } from "@nutrafol/nutrafol-ui-kit/dist/TextElementMen"
import { ButtonWildMen } from "@nutrafol/nutrafol-ui-kit/dist/ButtonWildMen"
import Tag from "../../../nova/tag/tag"

import Minus from "../../../../../assets/icons/men/minus.svg"
import Plus from "../../../../../assets/icons/men/plus.svg"

const Option = styled(Flex)`
  width: 100%;
  padding: 16px 16px;
  border-radius: 4px;
  border: 1px solid #0f3956;
  flex-direction: column;

  @media (min-width: 768px) {
    border-radius: 8px;
  }
  @media (min-width: 1280px) {
    padding: 16px 24px;
  }
`

const OptionFlex = styled(Flex)`
  align-items: center;
  gap: 8px;

  .tag-box {
    transform: translate(0, -2px);
    height: 18px;
    padding: 3px 7px !important;

    > span {
      color: #07253a !important;
    }
  }
`

const Counter = styled(Flex)`
  background: #fff;
  border-radius: 4px;
  border: 1px solid #c8d2d1;
  width: 96px;
  height: 48px;
  align-items: center;
  gap: 8px;
  padding: 8px;
  text-align: center;
  @media (min-width: 1024px) {
    height: 56px;
  }
`

const ATCButtonWrap = styled(Box)`
  flex: 1;

  button {
    width: 100%;
  }
`

const label = `Add to Cart`

const MenSingleOptionPromo2in1 = ({ data, purchase_source, max = 4 }) => {
  const option = data[0]
  const { sku, price, ui_data } = option
  const { title, subtitle } = ui_data

  const [quantity, setQuantity] = useState(1)
  const [submitted, setSubmitted] = useState(false)

  const onSetQuantity = (quantity) => {
    segmentEvent("Product Quantity Selected", {
      core_category: option.product_core_category || null,
      code: option?.ui_data?.code,
      name: option?.ui_data?.segmentName || option.option_title || option.title,
      price: option.new_price || option.price,
      product_gender: option.product_gender_new,
      product_category: option.product_category,
      purchase_type: option.purchase_type,
      quantity,
      sku: option.sku,
      variant: option.purchase_type,
    })
    setQuantity(quantity)
  }

  const onMinus = () => {
    if (quantity > 1) {
      onSetQuantity(quantity - 1)
    }
  }

  const onPlus = () => {
    if (quantity < max) {
      onSetQuantity(quantity + 1)
    }
  }

  const onAtcClick = () => {
    if (submitted) {
      return
    }
    setSubmitted(true)
    segmentEvent("Product Added", {
      billing_interval: option.billing_interval,
      core_category: option.product_core_category,
      code: option?.ui_data?.code,
      name: option?.ui_data?.segmentName || option.name,
      price: option.price,
      product_category: option.product_category,
      product_gender: option.product_gender,
      purchase_type: option.purchase_type,
      quantity,
      quiz_reco: false,
      shipping_interval: option.shipping_interval,
      sku: option.sku,
      source: purchase_source,
      text: label,
      type: "button",
      variant: option.title,
    })

    const url =
      process.env.GATSBY_MAGENTO_URL +
      `dpa/add/tocart?skus=${sku}|${quantity}&code=${option?.ui_data?.code}&purchase_source=${purchase_source}`
    window.location.href = url
  }

  return (
    <Box mt={[35, 35, 48]}>
      <Option className={`bg-men-brand-blue-20`}>
        <Flex width={1}>
          <Box flex="1" pr={16}>
            <OptionFlex>
              <Box>
                <TextElementMen
                  text={title}
                  className="title--small text-master-secondary-default"
                />
              </Box>
              <Box>
                <Tag
                  data={{
                    line: `$${option?.ui_data?.discount} off`,
                    classes: "bg-nova-base-white",
                    fontclasses: "text-men-brand-blue-100",
                  }}
                />
              </Box>
            </OptionFlex>
            <Box mt={[8]}>
              <TextElementMen
                text={subtitle}
                className="body--small text-master-base-black"
              />
            </Box>
          </Box>
          <Flex justifyContent={`space-between`} flexDirection={`column`}>
            <Box>
              <TextElementMen
                text={`$${price - option?.ui_data?.discount}`}
                className="title--small text-master-secondary-default"
              />
            </Box>
            <Box mt={[8]} className={`text-right`}>
              <TextElementMen
                text={`$${price}`}
                className="body--small text-master-base-alt-disabled line-through"
              />
            </Box>
          </Flex>
        </Flex>
        <Flex width={1} mt={[8]}>
          <Counter mr={[16]}>
            <Flex width={1 / 3}>
              <button
                className={`minus ${quantity === 1 ? "disabled" : ""}`}
                onClick={onMinus}
              >
                <Minus />
              </button>
            </Flex>
            <Box width={1 / 3}>
              <TextElementMen
                element="p"
                text={quantity}
                className="body--regular quantity"
              />
            </Box>
            <Flex width={1 / 3}>
              <button
                className={`plus ${quantity === max ? "disabled" : ""}`}
                onClick={onPlus}
              >
                <Plus />
              </button>
            </Flex>
          </Counter>
          <ATCButtonWrap>
            <ButtonWildMen
              label={label}
              primary
              onClick={onAtcClick}
              disabled={submitted}
            />
          </ATCButtonWrap>
        </Flex>
      </Option>
    </Box>
  )
}

export default MenSingleOptionPromo2in1
